document.addEventListener('DOMContentLoaded', function () {
  initRevelado();
  initGaleriaProducto();
  initVariantesProducto();
  initCantidad();
  initComparador();
});

function initRevelado() {
  var elementos = document.querySelectorAll('.sv-reveal');
  if (!elementos.length) return;

  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
    elementos.forEach(function (el) { el.classList.add('sv-visible'); });
    return;
  }

  var observer = new IntersectionObserver(
    function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('sv-visible');
          observer.unobserve(entry.target);
        }
      });
    },
    { threshold: 0.15 }
  );

  elementos.forEach(function (el, i) {
    el.style.setProperty('--sv-i', i % 6);
    observer.observe(el);
  });
}

function initGaleriaProducto() {
  var principal = document.querySelector('[data-sv-galeria-principal]');
  if (!principal) return;
  var miniaturas = document.querySelectorAll('[data-sv-miniatura]');
  miniaturas.forEach(function (mini) {
    mini.addEventListener('click', function () {
      var src = mini.getAttribute('data-full');
      var alt = mini.getAttribute('data-alt') || '';
      principal.querySelector('img').setAttribute('src', src);
      principal.querySelector('img').setAttribute('alt', alt);
      miniaturas.forEach(function (m) { m.classList.remove('is-activa'); });
      mini.classList.add('is-activa');
    });
  });
}

function initVariantesProducto() {
  var contenedor = document.querySelector('[data-sv-producto-form]');
  if (!contenedor) return;

  var datosEl = contenedor.querySelector('[data-sv-variantes-json]');
  if (!datosEl) return;
  var variantes = JSON.parse(datosEl.textContent);

  var envoltorio = contenedor.closest('.sv-producto__compra') || document;
  var selects = contenedor.querySelectorAll('[data-sv-opcion]');
  var idInput = contenedor.querySelector('[data-sv-variant-id]');
  var precioEl = envoltorio.querySelector('[data-sv-precio]');
  var precioTachadoEl = envoltorio.querySelector('[data-sv-precio-tachado]');
  var boton = contenedor.querySelector('[data-sv-boton-comprar]');

  function opcionesSeleccionadas() {
    var seleccion = [];
    selects.forEach(function (grupo) {
      var activo = grupo.querySelector('.is-activo');
      seleccion.push(activo ? activo.getAttribute('data-valor') : null);
    });
    return seleccion;
  }

  function encontrarVariante() {
    var seleccion = opcionesSeleccionadas();
    return variantes.find(function (v) {
      return v.options.every(function (op, i) { return op === seleccion[i]; });
    });
  }

  function formatearDinero(centavos) {
    return (centavos / 100).toLocaleString(document.documentElement.lang || 'es', {
      style: 'currency',
      currency: window.Shopify && window.Shopify.currency ? window.Shopify.currency.active : 'EUR',
    });
  }

  function actualizar() {
    var variante = encontrarVariante();
    if (!variante) return;
    idInput.value = variante.id;
    if (precioEl) precioEl.textContent = formatearDinero(variante.price);
    if (precioTachadoEl) {
      if (variante.compare_at_price && variante.compare_at_price > variante.price) {
        precioTachadoEl.textContent = formatearDinero(variante.compare_at_price);
        precioTachadoEl.style.display = '';
      } else {
        precioTachadoEl.style.display = 'none';
      }
    }
    if (boton) {
      boton.disabled = !variante.available;
      boton.querySelector('[data-sv-boton-texto]').textContent = variante.available
        ? boton.getAttribute('data-texto-disponible')
        : boton.getAttribute('data-texto-agotado');
    }
    mostrarImagenVariante(variante);
  }

  function rutaBase(url) {
    return (url || '').split('?')[0].replace(/^https?:/, '');
  }

  function mostrarImagenVariante(variante) {
    if (!variante.image) return;
    var principal = document.querySelector('[data-sv-galeria-principal] img');
    if (!principal || rutaBase(principal.getAttribute('src')) === rutaBase(variante.image)) return;
    principal.setAttribute('src', variante.image);
    document.querySelectorAll('[data-sv-miniatura]').forEach(function (m) {
      m.classList.toggle('is-activa', rutaBase(m.getAttribute('data-full')) === rutaBase(variante.image));
    });
  }

  selects.forEach(function (grupo) {
    grupo.querySelectorAll('[data-valor]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        grupo.querySelectorAll('[data-valor]').forEach(function (b) { b.classList.remove('is-activo'); });
        btn.classList.add('is-activo');
        actualizar();
      });
    });
  });

  actualizar();
}

function initComparador() {
  document.querySelectorAll('[data-sv-comparativa]').forEach(function (el) {
    function fijarPorcentaje(clientX) {
      var rect = el.getBoundingClientRect();
      var pct = ((clientX - rect.left) / rect.width) * 100;
      pct = Math.max(0, Math.min(100, pct));
      el.style.setProperty('--sv-reveal', pct + '%');
      el.setAttribute('aria-valuenow', Math.round(pct));
    }

    var arrastrando = false;

    el.addEventListener('pointerdown', function (e) {
      arrastrando = true;
      el.setPointerCapture(e.pointerId);
      fijarPorcentaje(e.clientX);
    });
    el.addEventListener('pointermove', function (e) {
      if (!arrastrando) return;
      fijarPorcentaje(e.clientX);
    });
    el.addEventListener('pointerup', function () { arrastrando = false; });
    el.addEventListener('pointercancel', function () { arrastrando = false; });

    el.addEventListener('keydown', function (e) {
      var actual = parseFloat(el.style.getPropertyValue('--sv-reveal')) || 50;
      if (e.key === 'ArrowLeft') { actual = Math.max(0, actual - 5); }
      else if (e.key === 'ArrowRight') { actual = Math.min(100, actual + 5); }
      else { return; }
      e.preventDefault();
      el.style.setProperty('--sv-reveal', actual + '%');
      el.setAttribute('aria-valuenow', Math.round(actual));
    });
  });
}

function initCantidad() {
  document.querySelectorAll('[data-sv-cantidad]').forEach(function (wrap) {
    var input = wrap.querySelector('input');
    var menos = wrap.querySelector('[data-sv-menos]');
    var mas = wrap.querySelector('[data-sv-mas]');
    if (!input || !menos || !mas) return;
    menos.addEventListener('click', function () {
      input.value = Math.max(1, parseInt(input.value || '1', 10) - 1);
    });
    mas.addEventListener('click', function () {
      input.value = parseInt(input.value || '1', 10) + 1;
    });
  });
}
